/** Mission ids (shared by the job files and the system; saves store them, so never rename one). */
export const BORROWED_TIME = 'borrowed-time';
export const WET_PAPER = 'wet-paper';
export const GULLET_JOB = 'gullet-job';
export const ONE_ARMED_BANDITS = 'one-armed-bandits';
export const THE_COLLECTION = 'the-collection';
export const LAST_ORDERS = 'last-orders';
export const EXPORT_ORDER = 'export-order';
export const STREET_JOB = 'street-job';

/** Save unlocks granted by jobs. */
export const UNLOCK_STREET_JOBS = 'street-jobs';
export const UNLOCK_MAGS_FIRM = 'mags-firm';
